import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const AddTransactionNote = createAsyncThunk("TransactionsContract/AddTransactionNote", async (data, thunkAPI) => {
  try {
    const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}api/transactions/contracts/notes`, data.noteDetail, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (data?.handleSuccess) {
      data?.handleSuccess();
    }
    return resp.data;
  } catch (error) {
    if (error.response) {
      data.handleError(error.response.data.errorMessage || error.response.data.message);
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      data.handleError(error.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
